import { RootState } from 'store';
import { IFitBounds } from 'common/types/map/fitBounds';

import { STATE } from '../types/state';

const selector = (state: RootState): IFitBounds => {
  const { fitBounds } = state[STATE].stations;
  return fitBounds;
};

export default selector;
